import { getEasing, getTimingFactor, toKeyframeValue } from '../../utils';
const POWER_EASING_MAP = {
  soft: 'linear',
  medium: 'quintInOut',
  hard: 'backOut'
};
const DIRECTION_MAP = {
  vertical: {
    x: '1',
    y: '0'
  },
  horizontal: {
    x: '0',
    y: '1'
  }
};
export function web(options, _dom) {
  return style(options, true);
}
export function style(options, asWeb) {
  if (asWeb === void 0) {
    asWeb = false;
  }
  const {
    direction = 'horizontal',
    power
  } = options.namedEffect;
  const duration = options.duration || 1;
  const delay = options.delay || 0;
  const offset = getTimingFactor(duration, delay);
  const [name] = getNames(options);
  const rotationAxes = DIRECTION_MAP[direction];
  const easing = power && POWER_EASING_MAP[power] || options.easing || 'linear';
  const custom = {
    '--motion-rotate-x': rotationAxes.x,
    '--motion-rotate-y': rotationAxes.y
  };
  const rotateStart = `rotate3d(${toKeyframeValue(custom, '--motion-rotate-x', asWeb)}, ${toKeyframeValue(custom, '--motion-rotate-y', asWeb)}, 0, 0deg)`;
  const rotateEnd = `rotate3d(${toKeyframeValue(custom, '--motion-rotate-x', asWeb)}, ${toKeyframeValue(custom, '--motion-rotate-y', asWeb)}, 0, 360deg)`;
  return [{
    ...options,
    name,
    delay: 0,
    easing: 'linear',
    duration: duration + delay,
    custom,
    keyframes: [{
      offset: 0,
      transform: `perspective(800px) rotateZ(var(--comp-rotate-z, 0deg)) ${rotateStart}`,
      easing: getEasing(easing)
    }, {
      offset,
      transform: `perspective(800px) rotateZ(var(--comp-rotate-z, 0deg)) ${rotateEnd}`
    }, {
      offset: 1,
      transform: `perspective(800px) rotateZ(var(--comp-rotate-z, 0deg)) ${rotateEnd}`
    }]
  }];
}
export function getNames(options) {
  const timingFactor = getTimingFactor(options.duration, options.delay, true);
  return [`motion-flip-${timingFactor}`];
}
//# sourceMappingURL=Flip.js.map